import React, { useState, useReducer, createContext } from "react"

export const AppContext: any = createContext({})

export const AppProvider = ({ children, config: siteConfig }): JSX.Element => {
  const [config] = useState(siteConfig || {})
  const [activeVariant, setActiveVariant] = useState(false)
  const [activeProduct, setActiveProduct] = useState(false)
  const [activeCollection, setActiveCollection] = useState(false)
  const [activeSubscribe, setActiveSubscribe] = useState(false)
  const [quizData, setQuizData] = useState({})
  const [activeHover, setActiveHover] = useState(``)
  const [filterScroll, setFilterScroll] = useState(false)
  const [footer, setFooter] = useState(false)
  const [totalCount, setTotalCount] = useState(0)
  // const [prevDirection, setprevDirection] = useState(0)
  const [searchTerms, setSearchTerms] = useState(``)
  const [activeGuide, setActiveGuide] = useState(false)
  const [cartHeight, setCartHeight] = useState(124)
  const [sortBy, setSortBy] = useState(null)
  const [searchResultNumber, setSearchResultNumber] = useState(undefined)

  const initialState = {
    activeCart: false,
    activeSearch: false,
    activeMenu: false,
    activeAccount: false,
    activeHover: "",
    quizData: {},
    activeGuide: false,
    totalCount: 0,
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case "setActiveCart":
        return {
          ...state,
          activeMenu: false,
          activeCart: action.payload,
          activeSearch: false,
          activeAccount: false,
        }
      case "setActiveSearch":
        return {
          ...state,
          activeMenu: action.payload ? true : state.activeMenu,
          activeSearch: action.payload,
          activeCart: false,
          activeAccount: false,
        }
      case "setFooter":
        return { ...state, footer: action.payload }
      case "setActiveMenu":
        return { ...state, activeMenu: action.payload, activeSearch: false, activeAccount: false, activeCart: false }
      case "setActiveHover":
        return { ...state, activeHover: action.payload }
      case "setActiveGuide":
        return { ...state, activeGuide: action.payload }
      case "setFilterScroll":
        return { ...state, filterScroll: action.payload }
      case "setTotalCount":
        return { ...state, totalCount: action.payload }
      // case "setprevDirection":
      //   return { ...state, prevDirection: action.payload }
      case "setCartHeight":
        return { ...state, cartHeight: action.payload }
      case "setActiveAccount":
        return {
          ...state,
          activeMenu: action.payload ? true : state.activeMenu,
          activeAccount: action.payload,
          activeSearch: false,
          activeCart: false,
        }
      case "setQuizData":
        return { ...state, quizData: { ...state.quizData, ...action.payload } }
      case "clearQuizData":
        return { ...state, quizData: {} }
      case "routeChange":
        return { ...state, activeMenu: false, activeSearch: false, activeCart: false, activeSubscribe: false }
      default:
        return state
    }
  }

  const globalStateReducer = useReducer(reducer, initialState)

  const values = {
    config,
    activeVariant,
    setActiveVariant,
    activeProduct,
    setActiveProduct,
    activeCollection,
    setActiveCollection,
    activeSubscribe,
    setActiveSubscribe,
    activeHover,
    setActiveHover,
    activeGuide,
    setActiveGuide,
    footer,
    setFooter,
    filterScroll,
    setFilterScroll,
    totalCount,
    setTotalCount,
    // prevDirection,
    // setprevDirection,
    cartHeight,
    setCartHeight,
    quizData,
    setQuizData,
    searchTerms,
    setSearchTerms,
    sortBy,
    setSortBy,
    searchResultNumber,
    setSearchResultNumber,
    globalStateReducer,
  }

  return <AppContext.Provider value={{ ...values, globalStateReducer: useReducer(reducer, initialState) }}>{children}</AppContext.Provider>
}

export const withApp =
  Component =>
  (props): JSX.Element =>
    <AppContext.Consumer>{values => <Component {...props} layout={values} />}</AppContext.Consumer>
